import React, { useContext } from 'react';
import { useFetch } from 'bv-hooks';
import { ScrollableContext } from 'bv-contexts';
import { Spinner } from 'bv-components';
import fetchComponents from '../../api';
import componentTypes from './casino_section_components';

/**
 * Right Sidebar section containing Right components
 * @returns {React.Component}
 */
const RightComponents = () => {
  const [components, loading] = (
    useFetch(fetchComponents)
  );
  const scrollableContext = useContext(ScrollableContext);

  if (loading) return <Spinner />;

  return (
    <section className="right-sidebar-components">
      {components.map(({ type, id, ...rest }) => {
        const Component = componentTypes[type];

        if (Component && rest.payload) {
          return (
            <Component
              key={id}
              componentId={id}
              scrollableRef={scrollableContext}
              {...rest}
            />
          );
        }

        return null;
      })}
    </section>
  );
};

export default RightComponents;
